<template>
  <div>
    <div v-if="!pageLoading">
      <top-card current="BranchSelections"
        :cover-type="coverType"
        :premium-amount="renewal.batchId.premiumAfterTax"
        :free-benefits="renewal.batchId.freeBenefits"
      >Please confirm that the information below is accurate before you proceed to pay</top-card>
      <div class="tw-flex tw-justify-center tw-justify-items-center tw-my-8">
        <back-nav to="PaymentSelection" />
      </div>
      <div>
        <div class="tw-w-full tw-p-10">
          <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">You can now select a valuer to your vehicle</h3>
          <hr class="tw-mt-3 tw-mb-5">
          <div class="tw-w-full tw-p-10 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-10">
            <div class="tw-grid tw-grid-flow-row tw-gap-5 tw-my-8 tw-grid-cols-1 md:tw-grid-cols-3">
                <div v-for="(valuer,i) in valuers" :key="i" :class="['pt-10 pb-5 px-10 tw-flex tw-flex-col  tw-align-center tw-justify-center tw-border-4 tw-shadow-lg  tw-rounded-lg', selectedValuerId===valuer.id?'tw-border-blue-500':'tw-border-gray-300']" @click="setValuerId(valuer.id)">
                  <img
                      :src="valuer.logoUrl"
                      :alt="[valuer.name, ' VALUERS']"
                  />
                  <h3 class="c-title c-gray-text tw-text-base tw-text-center">{{ valuer.name + ' VALUERS' }}</h3>
                  <h3 class="title-font c-blue-text tw-text-base tw-text-center">{{ valuer.phoneNumber }}</h3>
                </div>
            </div>
            <v-btn
                class="tw-normal-case tw-px-30 tw-rounded-none c-title"
                color="primary"
                large
                @click="dialog = true"
            >Next</v-btn>
          </div>

        </div>
      </div>

      <v-dialog
          v-model="dialog"
          @click:outside="dialog = false"
          persistent max-width="630px">
        <v-card>
          <v-card-text>
            <card-title>Select Valuation Date And time</card-title>
            <v-container class="tw-mt-10">
              <v-form v-model="form.isValid">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="form.dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="computedDateFormatted"
                            label="Date"
                            persistent-hint
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[required('Date')]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="form.date"
                          no-title
                          @input="menu = false"
                          :min="new Date().toLocaleDateString('en-CA')"
                          :allowed-dates="allowedDates"
                          :max="new Date().setDate(new Date() + 14).toLocaleString('en-CA')"
                          color="primary"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      label="Time of valuation"
                      v-model="form.time"
                      :items="['morning', 'afternoon']"
                      :rules="[required('Time')]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                        v-model="form.terms"
                        label="I agree to share my details for scheduling the valuation of my vehicle. I agree to present my vehicle for valuation and assessment within 14 days from the day of issuance of the insurance certificate. If I fail to do so, my comprehensive policy plan will be downgraded to third party policy plan"
                        :rules="[check()]"
                    ></v-checkbox>
                  </v-col>
                  <v-card-actions class="col-sm-4 offset-sm-4">
                    <v-btn block large
                           color="secondary"
                           class="my-3 "
                           @click="proceed"
                           :loading="pageLoading"
                           :disabled="!form.isValid"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>
<script>
import renewalMixin from '@/mixins/renewalMixin';
import TopCard from '@/components/renew/TopCard';
import BackNav from '@/components/buy/BackNav';
import axios from 'axios';
import CardTitle from '@/components/shared/CardTitle';
import { formatDate, timeNow } from '@/utils/time';
import validations from '@/utils/validations';
import scheduleInspection from '@/components/buy/ScheduleInspection';

export default {
  name: 'ValuerSelection',
  props: {
    renewal: {
      type: Object,
    },
  },
  components: { CardTitle, BackNav, TopCard },
  data() {
    return {
      selectedValuerId: null,
      pageLoading: false,
      valuers: [{
        id: null,
        name: null,
        identifier: null,
        phoneNumber: null,
        logoUrl: null,
        credentialType: null,
        status: true,
      }],
      ...validations,
      form: {
        isValid: true,
        dateMenu: false,
        date: '',
        time: '',
        location: '',
        terms: '',
      },
      dialog: false,
    };
  },
  mixins: [renewalMixin, scheduleInspection],
  mounted() {
    this.pageLoading = true;
    axios.get('/motor/api/valuers/all')
      .then((response) => {
        this.valuers = response.data.data;
        if (this.valuers && this.valuers?.length > 0) {
          this.selectedValuerId = this.valuers[0].id;
        }
        this.pageLoading = false;
      });
  },
  computed: {
    computedDateFormatted() {
      return formatDate(this.form.date);
    },
  },
  methods: {
    timeNow,
    setValuerId(valuerId) {
      this.selectedValuerId = valuerId;
    },
    proceed() {
      const selectedValuer = this.valuers?.find((valuer) => valuer.id === this.selectedValuerId);
      const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
      const payload = {
        address: 'Nairobi,  Kenya',
        customerId: formPayload.customerId,
        date: this.form.date,
        latitude: -1.292066,
        longitude: 36.821946,
        policyNo: this.$route.params.policyNo,
        time: this.form.time,
        valuerId: selectedValuer.id,
      };
      axios
        .post('/motor/api/policy/bookEvaluator', payload)
        .then((response) => {
          if (response.data.code === 0) {
            this.$toast.success('Evaluator details booked successfully',
              'Valuers details');
            this.$emit('to-branch-selection-review', this.renewal.batchId);
          } else {
            this.$toast.error(
              response.data.message,
              'Valuers Details Record error',
            );
          }
        });
    },
  },
};
</script>
